import types from './types';
import settings from './services';

const clearCurrent = () => {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_CURRENT });
  }
}

const getAll = (params) => {

  function request() { return { type: types.GETALL_REQUEST } }
  function success(payload) { return { type: types.GETALL_SUCCESS, payload } }
  function failure(error) { return { type: types.GETALL_FAILURE, error } }

  return async (dispatch, getState) => {
    console.log('ACTIONS::SETTINGS::getAll', params);
    dispatch(request());
    const response = await settings.getAll(params, getState().oauth.token)
    console.log('ACTIONS::SETTINGS::getAll::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }

  };  

}

const get = (id) => {
  console.log('ACTIONS::SETTINGS::get', id);

  const request = (id) => { return { type: types.GET_REQUEST, id } };
  const success = (payload) => { return { type: types.GET_SUCCESS, payload } }
  const failure = (error) => { return { type: types.GET_FAILURE, error } }

  return async (dispatch, getState) => {
    dispatch(request(id));
    let response = await settings.get(id, getState().users.auth.token)
    console.log('ACTIONS::SETTINGS::get::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }

  };

}

const saveOrUpdate = (setting) => {

  function request(payload) { return { type: types.SAVE_REQUEST, payload } }
  function success(payload) { return { type: types.SAVE_SUCCESS, payload } }
  function failure(error) { return { type: types.SAVE_FAILURE, error } }

  return async (dispatch, getState) => {
    console.log('ACTIONS::SETTINGS::saveOrUpdate', setting);
    dispatch(request(setting));

    let response;
    if (setting.id) {  // editing a existing record
      response = await settings.update(setting, getState().users.auth.token)
    } else {
      response = await settings.save(setting, getState().users.auth.token)
    }
    console.log('ACTIONS::SETTINGS::saveOrUpdate::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }
  };

}

const del = (id) => {
  console.log('ACTIONS::SETTINGS::del', id);
 
  function request(id) { return { type: types.DELETE_REQUEST, id } }
  function success(id) { return { type: types.DELETE_SUCCESS, id } }
  function failure(id, error) { return { type: types.DELETE_FAILURE, id, error } }

  return async (dispatch, getState) => {
    dispatch(request(id));
    let response = await settings.del(id, getState().users.auth.token)
    console.log('ACTIONS::SETTINGS::del::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(id));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }
  };

}

const getAllEvent = (params) => {

  function request() { return { type: types.GET_REQUEST_EVENT } }
  function success(payload) { return { type: types.GET_SUCCESS_EVENT, payload } }
  function failure(error) { return { type: types.GET_FAILURE, error } }

  return async (dispatch, getState) => {
    console.log('ACTIONS::SETTINGS::getAllEvent', params);
    dispatch(request());
    const response = await settings.getAll(params, getState().oauth.token)
    console.log('ACTIONS::SETTINGS::getAllEvent::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      if(response.data?.data?.length>0){
        dispatch(success({data: response.data?.data?.at(0)}));
      }else{
        dispatch(success(null));
      }
    } else {
        dispatch(failure(response.error));
    }
  };  
}


const actions = {
  clearCurrent,
  get,
  getAll,
  getAllEvent,
  saveOrUpdate,
  del,
};

export default actions;